module.exports = __webpack_public_path__ + "static/media/parvaz.fc81d4b6.png";